// 用户行为相关
export const POST_STUDENT_MY_COURSE = "/api/student/myCourseAct";
// 课程评分
export const POST_COURSE_SCORE_ADD = "/api/courseScore/add";
// 课程章节建议
export const POST_COURSE_SUGGESTION_ADD = "/api/courseSuggestions/add";
export const POST_STUDENT_FAVORITES = "/api/studentFavorites/addOrDelete";

export const POST_STUDENT_FAVORITES_LIST = "/api/studentFavorites/pageList";

export const POST_LEARNING_RECORD_LIST = "/api/learningRecord/pageList";

export const POST_BASE_EDIT_STUDENT_TYPE = "/api/student/editStudentType";

/**移动端首页学习进度 */
export const POST_MOBILE_LEARNING_RECORD = "/api/learningRecord/homeList";

/** 查询新证书列表 */
export const POST_CERT_BY_STUDENT = "/api/home/cert/byStudentCert";
// 主体信息查询列表
export const POST_STUDENT_SUBJECT_LIST = "/api/student/getSubjectList";
// 主体信息保存
export const POST_STUDENT_EDIT_SUBJECT = "/api/student/editSubject";
// 首页学习进度
export const POST_LEARNING_RECORD_HOME_LIST = "/api/learningRecord/homeList";
// 首页我的认证
export const POST_CERTIFICATEINFO_HOME_LIST = "/api/certificateInfos/list";
// 查询新消息
export const POST_NOTICE_NEW = "/api/notice/new";

// 主体信息审核信息
export const POST_STUDENT_QUERY_SUBJECT_INFO =
  "/api/student/queryBySubjectFrom";

// 主体信息审核提交
export const POST_STUDENT_QUERY_SUBJECT_SAVE = "/api/student/saveSubject";
// 文案编辑内容获取
export const POST_BASE_SITE_INFO = "/api/base/siteInfo";
// 岗位列表
export const POST_BASE_POSITION_LIST = "/api/base/positionList";



//----志成添加-----
// 继续学习接口
export const POST_COURSE_CONFIRM = "/api/course/newCourseConfirm";
//------end------
